import { Brain, Clapperboard, Home, type LucideIcon } from 'lucide-react';

// Shared between AppTopHeader (desktop) and MobileTabBar (mobile) so the redesigned routes' nav
// stays in sync across breakpoints instead of drifting into two hand-maintained copies.
export type AppNavItem = {
  path: string;
  label: string;
  icon: LucideIcon;
};

export const appNavItems: AppNavItem[] = [
  { path: '/meaning', label: 'Meaning', icon: Home },
  { path: '/training', label: 'Training', icon: Brain },
  { path: '/videos', label: 'Videos', icon: Clapperboard },
];

export const appHeaderNavItems = appNavItems.filter((item) => item.path !== '/videos');
